exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip-wrapper[data-v-dd925bc4] {\n  display: inline-block;\n}\n", ""]);

// exports
